var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeclineCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 14,
    viewBox: "0 0 35 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7721 8.01764C22.4963 7.27751 20.0489 6.875 17.5 6.875C14.9511 6.875 12.5037 7.27751 10.2279 8.01764C10.1522 8.04225 10.1144 8.05455 10.0547 8.0789C9.51374 8.29962 9.09831 8.84241 9.05268 9.38815C9.04765 9.44836 9.04765 9.5017 9.04765 9.60839C9.04765 9.97207 9.04765 10.1539 9.03132 10.3071C8.87316 11.7901 7.606 12.9634 6.00429 13.1099C5.83887 13.125 5.64249 13.125 5.24971 13.125H4.83633C4.05913 13.125 3.67054 13.125 3.34729 13.066C2.00384 12.8208 0.953535 11.8483 0.688717 10.6044C0.625 10.3051 0.625 9.94525 0.625 9.22562V8.916C0.625 8.17338 0.625 7.80206 0.710628 7.37648C0.902112 6.42477 1.64889 5.24728 2.45323 4.62881C2.81292 4.35223 3.05685 4.22624 3.54472 3.97424C7.67532 1.84072 12.4343 0.625 17.5 0.625C22.5657 0.625 27.3247 1.84072 31.4553 3.97424C31.9431 4.22624 32.1871 4.35223 32.5468 4.62881C33.3511 5.24728 34.0979 6.42477 34.2894 7.37648C34.375 7.80206 34.375 8.17338 34.375 8.916V9.22562C34.375 9.94525 34.375 10.3051 34.3113 10.6044C34.0465 11.8483 32.9962 12.8208 31.6527 13.066C31.3295 13.125 30.9409 13.125 30.1637 13.125H29.7503C29.3575 13.125 29.1611 13.125 28.9957 13.1099C27.394 12.9634 26.1268 11.7901 25.9687 10.3071C25.9523 10.1539 25.9523 9.97207 25.9523 9.60839C25.9523 9.5017 25.9523 9.44836 25.9473 9.38815C25.9017 8.84241 25.4863 8.29962 24.9453 8.0789C24.8856 8.05455 24.8478 8.04225 24.7721 8.01764Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeclineCallIcon);
export default __webpack_public_path__ + "static/media/IconDeclineCallIcon.70a5b7a537fb5add62eef816d216166c.svg";
export { ForwardRef as ReactComponent };